// 仅针对两个无关联的兄弟组件使用
import Vue from 'vue'
export default new Vue();



// WEBPACK FOOTER //
// ./src/utils/bus.js